/* 
 * Export component file to be used on project
*/

import RadioToggle from './RadioToggle';
export default RadioToggle;
